/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsUnderUtilizedSystemResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsUnderUtilizedSystemResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsUnderUtilizedSystemResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsUnderUtilizedSystemResource>): RecommendationForFinopsUnderUtilizedSystemResource {
        let obj = Object.assign(new RecommendationForFinopsUnderUtilizedSystemResource(), model);
        RecommendationForFinopsUnderUtilizedSystemResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsUnderUtilizedSystemResource>): RecommendationForFinopsUnderUtilizedSystemResource {
        if (!model) return null;
        return RecommendationForFinopsUnderUtilizedSystemResource.newInstance(<RecommendationForFinopsUnderUtilizedSystemResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsUnderUtilizedSystemResource) {
        if (!obj) return;

        models.RecommendationForFinopsUnderUtilizedSystemResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsUnderUtilizedSystemResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsUnderUtilizedSystemResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
